import { FormGroup } from '@angular/forms';
import { getControl, getGroup } from '@shared/helpers/form.helper';
import { formPaths } from '@shared/constants/form-paths.const';

export const getDatiIdentificativiGroup = (form: FormGroup): FormGroup => {
    return getGroup(form, formPaths.datiIdentificativi);
};

export const getDatiIdentificativiControl = (form: FormGroup, path: string) => {
    return getControl(form, `${formPaths.datiIdentificativi}.${path}`);
};
